export default function formatNumber(input: number | string | null | undefined): string {
    // 处理空值
    if (input === null || input === undefined || input === '') {
        return '';
    }

    // 转换为字符串并去除首尾空格
    const str = String(input).trim();

    // 检查是否为有效数字（允许正号、负号、一个小数点）
    if (!/^[+-]?\d*\.?\d*$/.test(str) || str === '-' || str === '+' || str === '.') {
        return String(input); // 返回原始值的字符串形式
    }

    // 提取符号和数字部分
    const isPositive = str.startsWith('+');
    const isNegative = str.startsWith('-');
    const [integerPart, decimalPart] = str.replace(/^[+-]/, '').split('.');

    // 处理整数部分，添加千位分隔符
    let formattedInteger = '';
    const len = integerPart.length;
    for (let i = len - 1, count = 0; i >= 0; i--) {
        formattedInteger = integerPart[i] + formattedInteger;
        count++;
        if (count % 3 === 0 && i !== 0) {
            formattedInteger = ',' + formattedInteger;
        }
    }

    // 拼接符号和数字部分
    const formatted = decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
    if (isPositive) {
        return '+' + formatted;
    } else if (isNegative) {
        return '-' + formatted;
    }
    return formatted;
}